import React, { useState, useEffect, useRef } from 'react';
// import { flushSync } from 'react-dom';
// import TextInput from '../../components/TextInput';
// import TextBody from '../../components/TextBody';

import TextInput from '../../atoms/text-input/text-input.atom';
import TextBody from '../../atoms/text-body/text-body.atom';

// import usetexts from '../../hooks/usetexts';
// import useChats from '../../hooks/useChats';

import {
    query,
    collection,
    orderBy,
    onSnapshot,
    limit,
} from "firebase/firestore";
import { db } from "../../utils/firebase.utils";


import Message from '../../components/message/message.component';
import SendMessage from '../../components/send-message/send-message.component';

import { ChattingBoxContainer, ChattingBox, Header, Main, Scroll, Footer } from './chat-page.styles';

const ChattingPage = () => {
    const friend = 'Eni';
    const code = 'jj6g';

    // const { chats, submitChat } = useChats();

    const [ texts, setTexts ] = useState([]);

    // useEffect(() => {
    //     // for(let i = 0; i < chats.length; i++) {
    //     //     if(code.toLowerCase() === chats[i].code ) {
    //     //         console.log(chats[i].texts);
    //     //         break;
    //     //     }
    //     // }
    // },[])

    const [messages, setMessages] = useState([]);
    const scroll = useRef();

    useEffect(() => {
        const q = query(
        collection(db, "messages"),
        orderBy("createdAt", "desc"),
        limit(50)
        );

        const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
        const fetchedMessages = [];
        QuerySnapshot.forEach((doc) => {
            fetchedMessages.push({ ...doc.data(), id: doc.id });
        });
        const sortedMessages = fetchedMessages.sort(
            (a, b) => a.createdAt - b.createdAt
        );
        setMessages(sortedMessages);
        });
        return () => unsubscribe;
    }, []);

    

    // const { texts, submitInbox } = usetexts();

   

    const [ textArray, setTextArray ] = useState(texts);
    const [ value, setValue ] = useState('');

    // const textRef = useRef();

    useEffect(() => {
        console.log(6)
        setTextArray(texts);
    }, [texts])

    const handleInputChange = (event) => {
        setValue(event.target.value);
        // setCurrentText(event.target.value);
    }


    const send = () => {
        if(!value || !value.replace(/\s/g, '').length ) {
            return setValue('');
        }

        textArray.push({
            type: 'sent',
            text: value,
            stat: '...'
        });
        
        // submitInbox({
        //     type: 'sent',
        //     text: value,
        //     stat: null
        // });

        setValue('');
    }

    useEffect(() => {
        setMessages(
            textArray.map((inbox, key) => {
                return < TextBody 
                    type={inbox.type} 
                    key={key} 
                    text={inbox.text}
                    stat={inbox.stat} 
                />
            })
        );
    },[textArray.length]);

    useEffect(() => {
        // textRef.current?.lastElementChild?.scrollIntoView()
    }, [messages]);
    

    return(
        <ChattingBoxContainer>
            <ChattingBox>
                <Header>
                    <h2>{friend}</h2>
                </Header>
                {/* <Main ref={textRef}>
                    {messages}
                </Main> */}

                <div className="messages-wrapper">
                    {messages?.map((message) => (
                    <Message key={message.id} message={message} />
                    ))}
                </div>
                <Footer>
                    {/* <TextInput
                        onChange={handleInputChange}
                        value={value}
                    />
                    <span onClick={send}>SEND</span> */}
                    <SendMessage scroll={scroll} />
                </Footer>
            </ChattingBox>
        </ChattingBoxContainer>
    )
}

export default ChattingPage;